import fetch from '@/utils/fetch';

/*用手机号登录*/
export function login(phone, password,captcha,captchaUUID) {
    return fetch({
        url: '/phoneLogin',
        method: 'post',
        data: {
            phone: phone,
            password:password,
            captcha:captcha,
            captchaUUID:captchaUUID
        }
    });
}
//新的 可用账号 或者手机登录新接口
export function unifyLogin(userName, password,captcha,captchaUUID) {
  return fetch({
    url: '/login',
    method: 'post',
    data: {
        userName: userName,
        password:password,
        captcha:captcha,
        captchaUUID:captchaUUID
    }
  });
}

export function getInfo() {
    return fetch({
        url: '/profile',
        method: 'get'
    });
}

export function changePassword(data) {
    return fetch({
        url: '/password',
        method: 'post',
        data
    });
}

export function logout() {
    return fetch({
        url: '/logout',
        method: 'post'
    });
}

export function haiLogin(obj) {
    return fetch({
        url: '/environmentAuth/autoLogin',
        method: 'post',
        data: obj
    })
}


//验证码
export function captchaImage() {
    return fetch({
        url: '/captcha/captchaImage ',
        method: 'get'
    });
}

export  function needChangePwd(params){
    return fetch({
        url:"/needChangePwd",
        method:'get',
        params
    })
}
//设置token过期时间
export  function refreshToken(){
    return fetch({
        url:"/refreshToken",
        method:'post',
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js